var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestoreFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#416AA5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-288q70 0 119-49t49-119q0-70-49-119t-119-49q-38.37 0-71.68 16.5Q375-591 352-564v-60h-48v144h144v-48h-64q17-22 42-35t54-13q49.85 0 84.92 35.11 35.08 35.11 35.08 85T564.92-371q-35.07 35-84.92 35-29 0-54-13t-42-35h-55q20 43 60 69.5t91 26.5ZM263.72-96Q234-96 213-117.15T192-168v-624q0-29.7 21.15-50.85Q234.3-864 264-864h312l192 192v504q0 29.7-21.16 50.85Q725.68-96 695.96-96H263.72Zm.28-72h432v-474L546-792H264v624Zm0 0v-624 624Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreFile);
export default __webpack_public_path__ + "static/media/restoreFile.08a47ab77ded907efdbfca1d13736c47.svg";
export { ForwardRef as ReactComponent };